import React, { useEffect, useState } from 'react';
import { Stack } from 'react-bootstrap';
import { useJobFavouriteQuery } from 'services';
import PaginationBox from 'components/PaginationBox';
import JobListingBox from 'components/Common/Jobs/JobListingBox';
import { dataLimits } from 'constants/index';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';
import useLocalizationStore from 'store/localization';

const FavouriteJobs: React.FC = () => {
	const { translate } = useTranslate();
	const { activeLanguage }: any = useLocalizationStore((state) => state);
	const [currentPage, setCurrentPage] = useState(1);

	const queryOptions = `limit=${dataLimits?.favouriteJobs}&page=${currentPage}`;
	const { data: { docs: jobs = [], meta = {} } = [], refetch } = useJobFavouriteQuery(queryOptions);
	const { limit = 10, totalDocs } = meta;

	useEffect(() => {
		refetch();
	}, [currentPage, activeLanguage]);

	return (
		<section className="applied-jobs">
			<div className="d-flex flex-column flex-lg-row gap-4">
				<div className="right-area flex-1 d-flex flex-column">
					<div className="white-box bg-white">
						<Stack className="gap-3 gap-md-4">
							<div className="jobs-filter d-flex align-items-center justify-content-between">
								<p className="fw-semibold mb-0">{translate('JobDetailBox.favouriteJobs')}</p>
							</div>
							{jobs?.length > 0 ? (
								jobs.map((job: any, index: number) => (
									<JobListingBox
										job={job}
										key={index}
										refetch={refetch}
										dataLength={jobs?.length}
										currentPage={currentPage}
										setCurrentPage={setCurrentPage}
									/>
								))
							) : (
								<Stack className="posted-job-box">
									<p className="mb-0">{translate('Common.noJobsFound')} </p>
								</Stack>
							)}
						</Stack>

						{totalDocs > limit && (
							<PaginationBox
								totalData={totalDocs}
								limit={limit}
								page={currentPage}
								setCurrentPage={setCurrentPage}
							/>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default FavouriteJobs;
